<template>
  <span
    class="bl-count"
    :class="`bl-count-${type} ${minified ? 'bl-count-minified' : ''}`"
    >{{ count }}</span
  >
</template>

<script>
export default {
  name: "BlBubbleCount",
  props: {
    count: {
      type: Number | String,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    minified: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.bl-count {
  position: relative;
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 5px;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1;
  color: var(--primary-color);
  padding: 0 0.375rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.bl-count::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: var(--primary-color);
  opacity: 0.1;
}
.bl-count.bl-count-minified {
  min-width: 1rem;
  height: 1rem;
  font-size: 0.625rem;
}
.bl-count.bl-count-secondary {
  color: #a0a0a0;
}
.bl-count.bl-count-secondary::before {
  background: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// src/components/BlBubbleCount.vue